import { render, staticRenderFns } from "./WebhookDetail.vue?vue&type=template&id=503f890e"
import script from "./WebhookDetail.vue?vue&type=script&lang=js"
export * from "./WebhookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports